import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { adminAPI } from '../api/userAPI';
import AdminPanel from './AdminPanel';
import SubscriptionAnalytics from './SubscriptionAnalytics';
import APIUsageAnalytics from './APIUsageAnalytics';
import WebhookEventLog from './WebhookEventLog';
import DarkModeToggle from './DarkModeToggle';

const AdminDashboard = ({ onBack }) => {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('pending-users');
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const userData = await adminAPI.getCurrentUser();
        setIsAdmin(userData.role === 'admin' || userData.role === 'super_admin');
      } catch (err) {
        console.error('Failed to check admin status:', err);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, []);

  if (loading) {
    return (
      <div className="admin-dashboard">
        <div className="loading">Checking admin privileges...</div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="admin-dashboard">
        <div className="access-denied">
          <h2>Access Denied</h2>
          <p>You don't have admin privileges to access this area.</p>
          <button onClick={onBack} className="back-button">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'pending-users':
        return <AdminPanel />;
      case 'subscription-analytics':
        return <SubscriptionAnalytics />;
      case 'webhook-logs':
        return <WebhookEventLog />;
      case 'api-usage':
        return <APIUsageAnalytics />;
      case 'user-management':
        return <div className="admin-section">User Management (Coming Soon)</div>;
      case 'system-settings':
        return <div className="admin-section">System Settings (Coming Soon)</div>;
      default:
        return <AdminPanel />;
    }
  };

  return (
    <div className="admin-dashboard">
      <DarkModeToggle />
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <div className="admin-user-info">
          <span>Welcome, {user?.full_name || user?.email}</span>
          <div className="admin-actions">
            <button onClick={logout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </div>

      <nav className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === 'pending-users' ? 'active' : ''}`}
          onClick={() => setActiveTab('pending-users')}
        >
          Pending Users
        </button>
        <button
          className={`admin-tab ${activeTab === 'subscription-analytics' ? 'active' : ''}`}
          onClick={() => setActiveTab('subscription-analytics')}
        >
          Subscription Analytics
        </button>
        <button
          className={`admin-tab ${activeTab === 'webhook-logs' ? 'active' : ''}`}
          onClick={() => setActiveTab('webhook-logs')}
        >
          Webhook Logs
        </button>
        <button
          className={`admin-tab ${activeTab === 'api-usage' ? 'active' : ''}`}
          onClick={() => setActiveTab('api-usage')}
        >
          API Usage
        </button>
        <button
          className={`admin-tab ${activeTab === 'user-management' ? 'active' : ''}`}
          onClick={() => setActiveTab('user-management')}
        >
          User Management
        </button>
        <button
          className={`admin-tab ${activeTab === 'system-settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('system-settings')}
        >
          System Settings
        </button>
      </nav>

      <div className="admin-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminDashboard;
